export default "__VITE_ASSET__DyCX81x6__"